import { Controller } from "stimulus"
import { saveLeadCaptureAnswers, storedLeadCaptureAnswersForForm } from "./lead_capture_session"

export default class extends Controller {
  static targets = [ "selector", "businessCard", "companyName", "howHeardOther" ]

  connect() {
    let initialServiceSelection = $(this.selectorTarget).find('input:checked').attr('data-service-type')
    this.serviceSelection = initialServiceSelection
    this.bindStoredLeadCaptureToSignup()
  }

  bindStoredLeadCaptureToSignup() {
    try {
      const signupId = this.element.dataset.leadCaptureSignupId || ""
      if (signupId) storedLeadCaptureAnswersForForm(signupId)
    } catch (_e) {
      // Binding cached answers must not stop the account form.
    }
  }

  rememberLeadCaptureAnswers() {
    try {
      const form = this.element
      const valueOf = (field) => {
        const el = form.querySelector(`[name="accounts_sign_up[${field}]"]`)
        return el ? el.value : ""
      }
      const howHeardEl = form.querySelector('[name="accounts_sign_up[how_heard]"]')
      const payload = {
        email: valueOf("email"),
        signup_id: form.dataset.leadCaptureSignupId || ""
      }
      if (howHeardEl) {
        payload.how_heard = howHeardEl.value
        payload.how_heard_other = valueOf("how_heard_other")
      }
      saveLeadCaptureAnswers(payload)
    } catch (_e) {
      // Remembering answers must not stop the account form.
    }
  }

  selectServiceType(event) {
    let serviceSelection = event.target.getAttribute('data-service-type');
    this.serviceSelection = serviceSelection
  }

  get serviceSelection() {
    return this.data.get('selectedService')
  }

  set serviceSelection(serviceSelection) {
    this.data.set('selectedService', serviceSelection)

    if (serviceSelection == 'residential') {
      $(this.businessCardTarget).hide()
      $(this.companyNameTarget).prop('required', false)

    } else if (serviceSelection == 'commercial') {
      $(this.businessCardTarget).show()
      $(this.companyNameTarget).prop('required', true)
    }
  }

  selectHowHeard(event){
    const target = event.target
    const value = $(target).val()
    let otherKeys = []
    try {
      otherKeys = JSON.parse(target.dataset.otherKeys || '[]')
    } catch (_e) {
      otherKeys = []
    }
    if (!Array.isArray(otherKeys) || otherKeys.length === 0) {
      otherKeys = ['other']
    }
    const isOther = otherKeys.includes(value)
    $(this.howHeardOtherTarget).toggle(isOther)
    $(this.howHeardOtherTarget).find('input').attr('required', isOther)
    if(!isOther){
      $(this.howHeardOtherTarget).find('input').val('')
    }
  }
}
